import React, { useState, useEffect } from 'react';
import { Table, message, Spin } from 'antd';
import { Infopiramide } from '../../../services/perfiles/conponentesServices';
import './tablaPi.css'
const TablaPiramideP = ({ municipioId }) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10, // Puedes ajustar el tamaño de página según lo necesario
    });

    const fetchData = async (params = {}) => {
        setLoading(true);
        setError('');
        try {
            const response = await Infopiramide(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                const currentYear = new Date().getFullYear().toString();  // Obtener el año actual como string
                const filteredData = fetchedData.filter(item => item.vigencia === currentYear);  // Filtrar datos por el año actual

                // Función para extraer la edad mínima de un rango
                const getMinAge = (rango) => {
                    const parts = rango.split('-').map(part => parseInt(part, 10));
                    return parts[0];  // Retorna la primera parte del rango como número
                };

                // Ordenar los datos por el rango de edad (edad mínima)
                const sortedData = filteredData.sort((a, b) => getMinAge(a.rango) - getMinAge(b.rango));

                setData(sortedData);
                setPagination({
                    ...params.pagination,
                    total: sortedData.length,
                });
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            setError('Error loading data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (municipioId) {
            fetchData({
            pagination,
        });     
        }
   
    }, [municipioId]);

    const handleTableChange = (pagination) => {
        fetchData({
            pagination,
        });
    };
    const columns = [
        {
            title: 'Rango',
            dataIndex: 'rango',
            key: 'rango',
            className: 'filaP',
            width: '7%',
        },
        {
            title: 'Porcentaje Hombres',
            dataIndex: 'porc_hombre',
            key: 'porc_hombre',
            className: 'filaP',
            width: '5%',
        },
        {
            title: 'Porcentaje Mujeres',
            dataIndex: 'porc_mujer',
            key: 'porc_mujer',
            className: 'filaP',
            width: '5%',
        },
        {
            title: 'Total',
            dataIndex: 'total',
            key: 'total',
            className: 'filaP',
            width: '5%',
        },
        {
            title: 'Vigencia',
            dataIndex: 'vigencia',
            key: 'vigencia',
            className: 'filaP',
            width: '6%',
        },
    ];

    return (

        <div >
            <h3>1.1 Pirámides poblacionales por edades
            </h3>
            {loading ? (
                <Spin size="large" />
            ) : (
                <div className="table-container">
                    <Table
                        columns={columns}
                        dataSource={data}
                        pagination={pagination}
                        onChange={handleTableChange}
                        rowKey="idpiramidepoblacional"
                        scroll={{ x: '100%' }}
                    />
                </div>
            )}
        </div>
    );
};
export default TablaPiramideP;
